module.exports = __webpack_public_path__ + "static/media/enagic-bg.129a54a0.jfif";